import { Get, Set } from "../../../../Request";

export const GetData = async (data, limit = 15, page = null) => {
  return await Get({
    url: "/blog/show_all",
    data: {
      limit: limit,
      best_coachs: true,
      offered_items: true,
      random_blogs: true,
      ...data,
    },
    page: page,
  }).then(data => {
    return data;
  });
};
export const GetBlog = async slug => {
  return await Get({
    url: "/blog/showbyslug",
    data: {
      best_coachs: true,
      offered_items: true,
      random_blogs: true,
      slug,
    },
  }).then(data => {
    return data;
  });
};
